export default __webpack_public_path__ + "static/media/PandD.e32d6e1e.svg";